// extracted by mini-css-extract-plugin
module.exports = {"form":"Register_form__3fYBS"};